<template>
  <!-- 网站头部(组件)
        @author: liuguisheng
        @date: 2019-11-5
  -->
  <div class="header">
    <!-- 头部 -->
    <div class="main-header" :class="{'main-header_fixed': isHeaderFixed}">
      <router-link to="/index" class="main-header_logo">
        <img :src="logo" alt="RICE" />
        <span>{{ webConfig.project.name }}</span>
      </router-link>
      <div class="main-header_nav">
        <router-link
          :to="el.path"
          active-class="active"
          v-for="(el, index) in webConfig.headNav"
          :key="index"
        >{{el.name}}</router-link>
        <div class="version-wrap">v{{version}}</div>
      </div>
    </div>
    <!-- 头部固定定位填充 -->
    <div style="height: 65px" v-if="isHeaderFixed"></div>
  </div>
</template>
<script>
// 网站配置信息引入
import webConfig from "../json/web.config.json";
// 导入项目配置
const packageConfig = require("../../package.json");

export default {
  name: "Header",
  data() {
    return {
      // 网站配置信息
      webConfig,
      // 头部是否固定
      isHeaderFixed: false,
      // 版本号
      version: packageConfig.version,
      // logo
      logo: require("../../src/assets/images/logo.png")
    };
  },
  methods: {
    /**
     * @name 跳转到首页
     * @returns { void }
     * @author liuguisheng
     * @version 2019-11-6
     */
    goToIndex() {
      this.$router.push({ path: "/index" });
    }
  },
  watch: {
    /**
     * @name 监听路由控制头部是否固定
     * @description 目前头部除了首页不固定，其他页面都固定
     * @param { object } val 路由信息
     * @returns { void }
     * @author liuguisheng
     * @version 2019-11-6
     */
    $route: {
      handler(val) {
        // 取出路由地址,根据地址判断是否固定
        let { fullPath } = val;
        this.isHeaderFixed = fullPath == "/index" ? false : true;
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
a {
   text-decoration: none;
}

.main-header_fixed {
  position: fixed;
  width: 100%;
  box-sizing: border-box;
  top: 0;
  z-index: 99;
}
.main-header {
  background-color: #fff;
  padding: 0 50px 0 30px;
  min-width: 700px;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px #f0f1f2;

  .main-header_logo {
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      img {
        transform: rotate(-15deg);
        transition: all 0.3s;
      }
    }
    img {
      width: 55px;
      transition: all 0.6s;
    }
    span {
      color: #4c4c4c;
      font-size: 24px;
      margin-left: 5px;
    }
  }

  .main-header_nav {
    display: flex;
    font-size: 14px;
    a {
      color: #4c4c4c;
      width: 80px;
      text-align: center;
      line-height: 65px;
      transition: color 0.3s;
      font-weight: 600;
      opacity: .8;
      letter-spacing: 1px;

      &:hover {
        color: #1fb19e;
        transition: color 0.3s;
      }
    }
    .active {
      color: #1fb19e;
      border-bottom: 2px solid #1fb19e;
    }
    .version-wrap {
      color: #5c5c5c;
      align-self: center;
      margin-left: 20px;
      padding-left: 40px;
      border-left: 1px solid #ccc;
      letter-spacing: 2px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// examples/components/Header.vue